import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper/modules';
import { FiLinkedin } from 'react-icons/fi';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/autoplay';
import './TeamSection.css';

const teamMembers = [
  {
    name: "Muhammet Emir Boz",
    role: "Project Coordinator",
    image: "https://res.cloudinary.com/dpuo4ow5h/image/upload/v1758660373/emirOk_dnujyk.png",
    linkedin: "https://www.linkedin.com/in/muhammet-emir-boz-821628220?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
  },
  {
    name: "Suleyman Asim Gelisgen",
    role: "Software Developer",
    image: "https://res.cloudinary.com/dpuo4ow5h/image/upload/v1765618615/Gemini_Generated_Image_6z9faq6z9faq6z9f_koz5g7.png",
    linkedin: "https://www.linkedin.com/in/suleyman-asim-gelisgen-b76b06162?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app"
  },
  {
    name: "Hasan Yasir Ozturk",
    role: "Graphic Designer",
    image: "https://res.cloudinary.com/dpuo4ow5h/image/upload/v1758660372/hasanOk_ynz0fg.png",
    linkedin: "https://www.linkedin.com/in/hasan-yasir-%C3%B6zt%C3%BCrk-4b5817223?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app"
  },
  {
    name: "Isa Caner Cal",
    role: "Software Developer",
    image: "https://res.cloudinary.com/dpuo4ow5h/image/upload/v1765618615/Gemini_Generated_Image_1ae2ya1ae2ya1ae2_l0cszq.png",
    linkedin: "https://www.linkedin.com/in/isa-caner-%C3%A7al-870869258?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app"
  },
  {
    name: "Fatma Zehra Cıftaslan",
    role: "Communication",
    image: "https://res.cloudinary.com/dpuo4ow5h/image/upload/v1758660373/zehraOk_avygwu.png",
    linkedin: "http://linkedin.com/in/fatma-zehra-çiftaslan"
  },
  {
    name: "Ummu Rukiye Keskin",
    role: "International Relations",
    image: "https://res.cloudinary.com/dpuo4ow5h/image/upload/v1765618615/Gemini_Generated_Image_yp2jgqyp2jgqyp2j_pg4ajj.png",
    linkedin: "https://www.linkedin.com/in/ummu-rukiye-keskin-b55a5632a?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app"
  },
  
];

const TeamSection = () => (
  <section className="team-section">
    <div className="container">
      <motion.h2
        className="team-section-title"
        initial={{ opacity: 0, y: 40, scale: 0.92, letterSpacing: "0.2em" }}
        whileInView={{ opacity: 1, y: 0, scale: 1, letterSpacing: "0em" }}
        transition={{
          duration: 0.8,
          ease: [0.22, 0.9, 0.32, 1],
          letterSpacing: { duration: 0.6 }
        }}
        viewport={{ once: true }}
      >
        Meet Our Team
      </motion.h2>
      <div className="team-slider-container">
        <Swiper
          modules={[Navigation, Autoplay]}
          spaceBetween={32}
          slidesPerView={1}
          navigation
          loop
          autoplay={{ delay: 1800, disableOnInteraction: false }}
          breakpoints={{
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 3 }
          }}
          className="team-swiper"
        >
          {teamMembers.map((member, idx) => (
            <SwiperSlide key={member.name}>
              <motion.div
                className="team-card"
                initial={{ opacity: 0, y: 24, scale: 0.96 }}
                whileInView={{ opacity: 1, y: 0, scale: 1 }}
                transition={{ duration: 0.6, delay: idx * 0.1 }}
                viewport={{ once: true }}
              >
                <div className="team-card-image-wrap">
                  <img src={member.image} alt={member.name} className="team-card-image" />
                </div>
                <div className="team-card-info">
                  <div>
                    <div className="team-card-name">{member.name}</div>
                    <div className="team-card-role">{member.role}</div>
                  </div>
                  <a
                    href={member.linkedin}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="team-card-linkedin"
                    aria-label="LinkedIn"
                  >
                    <FiLinkedin />
                  </a>
                </div>
              </motion.div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      <div className="team-section-cta-wrap">
        <Link to="/about#team" className="team-section-cta">
          Learn more about our team
        </Link>
      </div>
    </div>
  </section>
);

export default TeamSection;